import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { HttpResponse, RQAPICall } from 'store/APIClient';
import { useDispatch } from 'store/hooks';

const deleteProject = async ({
    projectId,
}: {
    projectId: number;
}): Promise<HttpResponse<object>> => {
    const response = await RQAPICall<object>({
        endpoint: `projects/${projectId}`,
        method: 'DELETE',
    });
    return response;
};

export const useDeleteProjectsMutation = () => {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation({
        mutationFn: ({ projectId }: { projectId: number }) =>
            deleteProject({ projectId }),

        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['projects'],
            });
            dispatch.vision.notifyUser({
                message: t('adminBudgetSpace.removeProjectModal.success'),
                snackType: 'success',
            });
        },

        meta: {
            useGlobalOnError: true,
        },
    });
};
